import React from 'react';
import classNames from 'classnames';
import styles from './DesignerServiceTag.module.scss';

interface IDesignerServiceTagProps {
  isInPerson: boolean;
  className?: string;
}

/**
 * Renders a designer's service type as an In-Person or Online tag — a tinted
 * pill badge used on both the designer profile page and the city-page cards.
 */
const DesignerServiceTag = ({
  isInPerson,
  className,
}: IDesignerServiceTagProps) => {
  const label = isInPerson ? 'In-Person Designer' : 'Online Designer';

  return (
    <span
      className={classNames(
        styles.Tag,
        styles.Pill,
        isInPerson ? styles.InPerson : styles.Online,
        className,
      )}
    >
      {label}
    </span>
  );
};

export default DesignerServiceTag;
